import { componentOutletConfigFactory } from '@core/common-legacy';
import { injectTranslate } from '@core/i18n-legacy';
import { Priority } from '@core/offers-types';
import { EMPTY_CELL } from '@core/user-interface-legacy';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../offer-columns';
import { PriorityCellComponent } from '../priority-cell/priority-cell.component';

export const priorityColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.Priority,
  label: injectTranslate()('app.offers.table.priority'),
  visible: true,
  geometry: {
    width: 130,
    minWidth: 130,
    maxWidth: 150,
  },
  options: {
    draggable: false,
    resizable: false,
    removable: true,
    sortable: false,
  },
  componentFactory: ({ row }) => {
    if (row.priority) {
      const iconColorToken = getPriorityIconColorToken(row.priority);
      const label = getPriorityLabel(row.priority);

      return componentOutletConfigFactory(PriorityCellComponent, {
        inputs: { priority: { iconColorToken, label } },
      });
    } else {
      return EMPTY_CELL;
    }
  },
}));

const getPriorityIconColorToken = (priority: Priority) => {
  switch (priority) {
    case Priority.Low:
      return 'colorIconLowDisabled';
    case Priority.Normal:
      return 'colorIconPrimaryDefault';
    case Priority.High:
      return 'colorIconWarningDefault';
    case Priority.Urgent:
      return 'colorIconCriticalStrongDefault';
    default:
      return 'colorIconDefault';
  }
};

const getPriorityLabel = (priority: Priority) => {
  const t = injectTranslate();
  switch (priority) {
    case Priority.Low:
      return t('app.options.offer.priorities.low');
    case Priority.Normal:
      return t('app.options.offer.priorities.normal');
    case Priority.High:
      return t('app.options.offer.priorities.high');
    case Priority.Urgent:
      return t('app.options.offer.priorities.urgent');
    default:
      return t('app.options.offer.priorities.low');
  }
};
